import UploadService from './services';
import UploadTypes from './types';

export const upload = (files: File | Blob, type: any, filename?: string, refId?: string | number, invoiceId?: any) =>
  UploadTypes.upload.createAction(() => UploadService.upload(files, type, filename, refId, invoiceId));
